import { ChangeEvent, useState } from "react";

import { Button, Input } from "@material-ui/core";

export default function AddCalleeFieldForm({
  onCancel,
  onSubmit
}: {
  onCancel: () => any;
  onSubmit: (name: string) => any;
}): JSX.Element {
  const [name, setName] = useState("");

  const resetState = () => setName("");

  const handleChangeName = (event: ChangeEvent<HTMLInputElement>) =>
    setName(event.target.value);

  const handleSubmit = async () => {
    await onSubmit(name);
    resetState();
  };

  const handleCancel = () => {
    resetState();
    onCancel();
  };

  return (
    <div>
      <Input value={name} onChange={handleChangeName} />
      <Button disabled={name.length < 1} onClick={handleSubmit}>
        Save
      </Button>
      <Button onClick={handleCancel}>Cancel</Button>
    </div>
  );
}
